import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { b as getDefaultFilters, M as MarketplaceContext } from "./OffersContext-CKQZ2fOu.js";
const MarketplaceProvider = ({ children, defaultFilters = [] }) => {
  const [filters, setFilters] = useState(getDefaultFilters(defaultFilters));
  return /* @__PURE__ */ jsx(
    MarketplaceContext.Provider,
    {
      value: {
        filters,
        setFilters
      },
      children
    }
  );
};
export {
  MarketplaceProvider as M
};
//# sourceMappingURL=MarketplaceProvider-DNmq4EgO.js.map
